import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import { getAllVendors } from "../../services/catalogServices";

const VendorSelector = ({ onVendorChange, value, fullWidth }) => {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;

    if (!open) {
      return undefined;
    }

    (async () => {
      setLoading(true);
      try {
        const data = await getAllVendors();
        if (active && data) {
          const mapped = data
            .map((v) => ({
              id: v.vendorListId,
              label: v.businessName,
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
          setOptions(mapped);
        }
      } catch (error) {
        console.error("Errore nel caricamento dei vendor:", error);
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, [open]);

  return (
    <Autocomplete
      id="vendor-selector"
      size="small"
      sx={{ width: fullWidth ? "100%" : 180 }}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      getOptionLabel={(option) => option.label || ""}
      options={options}
      loading={loading}
      value={value}
      onChange={(event, newValue) => {
        onVendorChange(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Ecommerce..."
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={16} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              fontSize: "13px",
              height: "36px",
              backgroundColor: "#f8fafc",
              borderRadius: "10px",
              "& fieldset": { borderColor: "#e2e8f0" },
              "&:hover fieldset": { borderColor: "#cbd5e1" },
              "&.Mui-focused fieldset": { borderColor: "#0b3d87" },
            },
            "& .MuiOutlinedInput-input": {
              padding: "0 12px !important",
            },
          }}
        />
      )}
    />
  );
};

VendorSelector.propTypes = {
  onVendorChange: PropTypes.func.isRequired,
  value: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  fullWidth: PropTypes.bool,
};

export default VendorSelector;
